import React, { createContext, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import MeetingNoteFlow from './MeetingNoteFlow';

type MeetingNoteContextType = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

const MeetingNoteContext = createContext<MeetingNoteContextType>({} as MeetingNoteContextType);

export function useMeetingNote() {
  const context = useContext(MeetingNoteContext);
  if (context === undefined) {
    throw new Error('useMeetingNote must be used within a MeetingNoteProvider');
  }
  return context;
}

export default function MeetingNoteProvider({ children }: { children: React.ReactNode }) {
  const [opened, { open, close }] = useDisclosure(false);

  const value = {
    opened,
    open,
    close,
  };

  return (
    <MeetingNoteContext.Provider value={value}>
      {children}
      <MeetingNoteFlow opened={opened} close={close} />
    </MeetingNoteContext.Provider>
  );
}
